import React from "react";
import {  useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {isValidHttpUrl} from "../../services/Util";
import { useTranslation } from "react-i18next";
import MultiFileDragUpload from "../global/MultiFileDragUpload";
export default function UploadFile() {
  const params = useParams();
  const projectData = useSelector(
    (reduxStore) => reduxStore.project_info
  ).value;
  const { t } = useTranslation();
  const translate = t;
  return (
    <>
      {projectData.projectRequest?.id &&
        projectData.projectRequest?.sourceMaterialDescription && (
          <>
            <h3 className="clear">
              {translate(
                "project_listing.project_request.source.description_display"
              )}
            </h3>
            <p id="sourceLink">
              {isValidHttpUrl(
                projectData.projectRequest?.sourceMaterialDescription
              ) ? (
                <a
                  id={"source-doc-" + projectData.projectRequest?.id}
                  target="_blank"
                  href={projectData.projectRequest?.sourceMaterialDescription}
                >
                  {projectData.projectRequest?.sourceMaterialDescription}
                </a>
              ) : (
                projectData.projectRequest?.sourceMaterialDescription
              )}
            </p>
          </>
        )}

      <MultiFileDragUpload projectId={params.id}/>
    </>
  );
}
